import { createAction, props } from '@ngrx/store';

import { ChatDraft } from '@lib/chat/models/chat.state.interface';

export const getChatDrafts = createAction('[Chat] Get chat drafts from storage');
export const getChatDraftsSuccess = createAction('[Chat] Get chat drafts from storage success', props<{ chatDrafts: ChatDraft[] }>());

export const setChatDraft = createAction('[Chat] Set chat draft message into store', props<{ chatDraft: ChatDraft }>());

export const clearChatDraftByThread = createAction('[Chat] Clear chat draft message by thread', props<{ chatDraft: ChatDraft }>());
export const clearChatDrafts = createAction('[Chat] Clear all chat draft messages');
